import { call, put, select } from 'redux-saga/effects';

import * as actions from './meeting-tasks.actions';
import { IMeetingSimple } from '../../../resource/meeting-simple/meeting-simple.types';
import * as taskSimpleResourceService from '../../../resource/task-simple/task-simple.saga-service';
import { ITaskSimple } from '../../../resource/task-simple/task-simple.types';
import { IBoardItem, ICalendarItem, IMeetingItem, IMeetingTasks, ISimpleTasks } from './meeting-tasks.types';
import { meetingTasksPageSelectors } from './meeting-tasks.selectors';
import { isActionItem, isActive, isGoal } from '../tasks-simple/tasks-simple.saga-services';

export function* setupMeetingTasks(meetingId: IMeetingSimple['id']) {
  const meetingTasksIds = (yield select(meetingTasksPageSelectors.selectMeetingTasks)) as IMeetingTasks;
  let tasksSimple: ITaskSimple[] = [];

  if (!!meetingTasksIds[meetingId]) {
    return;
  }

  tasksSimple = (yield call(taskSimpleResourceService.searchTasks, { meetingId: meetingId })) as ITaskSimple[];
  const actionItems = yield call(setupActionItems, tasksSimple);
  const goals = yield call(setupGoals, tasksSimple);
  const boardTasks = yield call(setupBoardTasks, tasksSimple);
  const calendarTasks = yield call(setupCalendarTasks, tasksSimple);

  meetingTasksIds[meetingId] = { actionItems, goals, boardTasks, calendarTasks };

  yield put(actions.storeMeetingTasks(meetingTasksIds));
}

export function setupActionItems(tasks: ITaskSimple[]) {
  const actionItems: IMeetingItem = {};

  tasks.forEach((task) => {
    if (isActionItem(task)) {
      if (task.members.length !== 0) {
        task.members.forEach((member) => {
          if (!!actionItems[member]) {
            if (isActive(task)) {
              actionItems[member].active.push(task.id);
            } else {
              actionItems[member].done.push(task.id);
            }
          } else {
            const taskStatuses: ISimpleTasks = { active: [], done: [] };
            if (isActive(task)) {
              taskStatuses.active.push(task.id);
            } else {
              taskStatuses.done.push(task.id);
            }
            actionItems[member] = taskStatuses;
          }
        });
      }
    }
  });

  return actionItems;
}

export function setupGoals(tasks: ITaskSimple[]) {
  const goals: IMeetingItem = {};

  tasks.forEach((goal) => {
    if (isGoal(goal)) {
      if (!!goals[goal.userId]) {
        if (isActive(goal)) {
          goals[goal.userId].active.push(goal.id);
        } else {
          goals[goal.userId].done.push(goal.id);
        }
      } else {
        const taskStatuses: ISimpleTasks = { active: [], done: [] };
        if (isActive(goal)) {
          taskStatuses.active.push(goal.id);
        } else {
          taskStatuses.done.push(goal.id);
        }
        goals[goal.userId] = taskStatuses;
      }
    }
  });

  return goals;
}

export function setupBoardTasks(tasks: ITaskSimple[]) {
  const boardTasks: IBoardItem = {};
  tasks.forEach((task) => {
    if (task.taskTypeId !== '1' && !!task.taskTypeId) {
      if (!!boardTasks[task.taskTypeId]) {
        if (isActive(task)) {
          boardTasks[task.taskTypeId].active.push(task.id);
        } else {
          boardTasks[task.taskTypeId].done.push(task.id);
        }
      } else {
        const taskStatuses: ISimpleTasks = { active: [], done: [] };
        if (isActive(task)) {
          taskStatuses.active.push(task.id);
        } else {
          taskStatuses.done.push(task.id);
        }
        boardTasks[task.taskTypeId] = taskStatuses;
      }
    }
  });

  return boardTasks;
}

export function setupCalendarTasks(tasks: ITaskSimple[]) {
  const calendarTasks: ICalendarItem = {};

  tasks.forEach((task) => {
    if (!!task.dueDate) {
      const dueDate = task.dueDate.slice(0, 10);
      if (!!calendarTasks[dueDate]) {
        if (isActive(task)) {
          calendarTasks[dueDate].active.push(task.id);
        } else {
          calendarTasks[dueDate].done.push(task.id);
        }
      } else {
        const taskStatuses: ISimpleTasks = { active: [], done: [] };
        if (isActive(task)) {
          taskStatuses.active.push(task.id);
        } else {
          taskStatuses.done.push(task.id);
        }
        calendarTasks[dueDate] = taskStatuses;
      }
    }
  });

  return calendarTasks;
}

// export function* createTaskSimple(taskInfo: ITaskSimpleCreateForm) {
//   const task = (yield call(
//     taskSimpleResourceService.createTaskSimple,
//     mapTaskSimpleFormToTaskSimpleCreate(taskInfo),
//   )) as ITaskSimple;
//   if (!task) {
//     return;
//   }
//   yield call(dialogService.closeDialog, 'taskFormDialog');
// }

// export function* updateTaskSimple(taskId: ITaskSimple['id'], taskInfo: ITaskSimpleCreateForm) {
//   const task = (yield call(taskSimpleResourceService.updateTaskSimple, {
//     ...mapTaskSimpleFormToTaskSimpleCreate(taskInfo),
//     id: taskId,
//   })) as ITaskSimple;

//   if (!task) {
//     return;
//   }
//   yield call(dialogService.closeDialog, 'taskFormDialog');
// }

// export function* deleteTaskSimple(taskId: ITaskSimple['id']) {
//   yield call(taskSimpleResourceService.deleteTaskSimple, taskId);
// }

// export const mapTaskSimpleFormToTaskSimpleCreate = (taskInfo: ITaskSimpleCreateForm): ITaskSimpleCreate => ({
//   title: taskInfo.title,
//   description: taskInfo.description,
//   dueDate: serializeDate(taskInfo.dueDate),
//   reminder: taskInfo.reminder ? taskInfo.reminder.value : '',
//   userId: taskInfo.user.value,
//   meetingIds: taskInfo.meeting.map((m) => m.value),
//   type: taskInfo.type,
//   status: taskInfo.status ? taskInfo.status.value : '0',
//   label: [],
//   taskTypeId: taskInfo.taskTypeId,
//   members: [],
//   showInTasks: taskInfo.showInTasks ? taskInfo.showInTasks : '1',
//   boardId: taskInfo.boardId,
// });

export function* clearMeetingTasksPageStorage() {
  yield put(actions.clearMeetingTasks());
}
